import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { KioskCartFunnelRadioItemBlockConfig } from '@front-platform/content-builder';
import { kioskCartFunnelRadioItemBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';

import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { Observable } from 'rxjs';
export interface KioskCartFunnelRadioItemBlockRuntimeConfig {
  'block_id'?: string;
  'form_id'?: string;
  'color'?: IContentBuilderFieldColor | undefined;
}

export type KioskCartFunnelRadioItemBlockConfigInput = Partial<
  Omit<KioskCartFunnelRadioItemBlockConfig, keyof KioskCartFunnelRadioItemBlockRuntimeConfig> &
    KioskCartFunnelRadioItemBlockRuntimeConfig
>;
export type KioskCartFunnelRadioItemBlockResolvedConfig = Omit<
  KioskCartFunnelRadioItemBlockConfig,
  keyof KioskCartFunnelRadioItemBlockRuntimeConfig
> &
  Partial<KioskCartFunnelRadioItemBlockRuntimeConfig>;
export interface KioskCartFunnelRadioItemBlockContract extends ConfigComponentContract<
  KioskCartFunnelRadioItemBlockConfigInput,
  KioskCartFunnelRadioItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-kiosk-cart-funnel-radio-item-block',
  templateUrl: './kiosk-cart-funnel-radio-item-block.component.html',
  standalone: false,
})
export class KioskCartFunnelRadioItemBlockComponent
  implements OnInit, KioskCartFunnelRadioItemBlockContract
{
  readonly config = input<KioskCartFunnelRadioItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    KioskCartFunnelRadioItemBlockConfig,
    KioskCartFunnelRadioItemBlockRuntimeConfig
  >(kioskCartFunnelRadioItemBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get required(): boolean {
    return this.resolvedConfig()['required'] as unknown as boolean;
  }
  get options(): any {
    return this.resolvedConfig()['options'] as unknown as any;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get formId(): string {
    return this.resolvedConfig()['form_id'] as unknown as string;
  }
  get color(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['color'] as unknown as IContentBuilderFieldColor | undefined;
  }
  get textColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor | undefined;
  }
  get buttonColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['button_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get activeTextColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['active_text_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get activeButtonColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['active_button_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }

  funnelUsername$: Observable<string | null> = this.cartFunnelSelector.selectfunnelUsername;

  constructor(
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
    private cartFunnelSelector: CartFunnelStoreSelector,
  ) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.addValue({
      id: this.blockId,
      title: this.title,
      formId: this.formId,
      required: this.required,
      displayTitle: true,
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(KioskCartFunnelRadioItemBlockComponent, {
  'keyAliases': {},
});
